<template>
		<div class="col-md-12 slider m-b-5">
			<transition-group name="slide" tag="ul" class="list-unstyled">
				<li v-for="item in itemsDisplay" v-bind:key="item.id">
					<div class="well well-shadow row" v-html=item.content></div>
				</li>
			</transition-group>
		</div>
</template>

<script>
export default {
	name: 'jobs-ticker',
	data() {
		return {
			settings: {
				speed: 4000,
				limit: 3,
			},
			itemsDisplay: [],
			start: -1, // this makes sure the ticker starts on item 0
			count: 0
		}
	},
	props: {
		items: Array
	},
	mounted() {
		this.count = this.items.length;

		let count = this.count > this.settings.limit ? this.settings.limit : this.count;

		for (let i = 0; i < count; i++) {
			this.updateList();
		}

		if (this.count > this.settings.limit) {
			this.$options.interval = setInterval(this.updateList, this.settings.speed);
		}
	},
	beforeDestroy() {
		clearInterval(this.$options.interval);
	},
	methods: {
		updateList() {
			this.start++;

			// Reset if we reach the end of the items
			if (this.start === this.count) {
				this.start = 0;
			}

			// Add an item to the list
			this.itemsDisplay.push({
				id: this.start,
				content: this.items[this.start].innerHTML
			});

			// Remove last item when the limit is reached
			if (this.itemsDisplay.length > this.settings.limit) {
				this.itemsDisplay.shift();
			}
		}
	}
}
</script>

<style>
.slider {
	overflow: hidden;
	max-height: 420px;
}

.slider .well-shadow {
	margin-left: 1px;
	margin-right: 1px;
}

.slider li .well {
	min-height: 12rem;
}

.slide-enter-active, .slide-leave-active {
	transition: margin-top 1s ease-in-out;
}

.slide-leave-to {
	margin-top: -14rem;
}

.slide-enter {
	margin-top: 0;
}

.slide-enter-to, .slide-leave {
	margin-top: 0;
}

@media (max-width: 768px) {
	.slider {
		max-height: 520px;
	}

	.slider li .well {
		min-height: 15rem;
	}

	.slide-leave-to {
		margin-top: -17rem;
	}
}
</style>
